import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "additional-services-config-add-modal",
    attrs: {
      "data-sign": "product_additional_add_edit_modal",
      "width": 600,
      "title": _vm.isEdit ? _vm.t('编辑规则') : _vm.t('新增规则')
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-alert', {
    staticClass: "mb-20",
    attrs: {
      "message": $t("\u82E5\u672A\u914D\u7F6E\u9002\u7528\u4ED3\u5E93\u4EE3\u8868\u5168\u533A\u57DF\u4ED3\u8BA2\u5355\u5747\u9002\u7528\u89C4\u5219"),
      "type": "info",
      "show-icon": ""
    }
  }), _c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "layout": "vertical",
      "data-sign": "product_additional_add_form",
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7F16\u7801"),
      "prop": "product_sku",
      "label": _vm.t('商品编码')
    }
  }, [_c('request-auto-complete', {
    attrs: {
      "searchFunction": _vm.handleSearchSkuList,
      "disabled": _vm.isEdit,
      "placeholder": _vm.t('请选择')
    },
    on: {
      "blur": function ($event) {
        return _vm.handleCheckSelectedProductSku(_vm.formData.product_sku || '');
      },
      "select": _vm.handleSelectProductSku
    },
    model: {
      value: _vm.formData.product_sku,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "product_sku", $$v);
      },
      expression: "formData.product_sku"
    }
  }, [_c('template', {
    slot: "dataSource"
  }, _vm._l(_vm.productList, function (item) {
    return _c('a-select-option', {
      key: item.product_sku,
      attrs: {
        "value": item.product_sku
      }
    }, [_vm._v(_vm._s(item.product_sku))]);
  }), 1)], 2)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9644\u52A0\u670D\u52A1\u9879"),
      "prop": "additional_service_code_list",
      "label": _vm.t('附加服务项')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-tip": "",
      "mode": "multiple",
      "max-tag-count": 1,
      "placeholder": _vm.t('请选择附加服务项'),
      "allowClear": ""
    },
    model: {
      value: _vm.formData.additional_service_code_list,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "additional_service_code_list", $$v);
      },
      expression: "formData.additional_service_code_list"
    }
  }, _vm._l(_vm.additionalServiceItemList, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9002\u7528\u4ED3\u5E93(\u533A\u57DF)"),
      "prop": "warehouse_code_list",
      "label": _vm.t('适用仓库(区域)')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-tip": "",
      "mode": "multiple",
      "max-tag-count": 1,
      "placeholder": _vm.t('请选择使用仓库(区域)'),
      "allowClear": ""
    },
    model: {
      value: _vm.formData.warehouse_code_list,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "warehouse_code_list", $$v);
      },
      expression: "formData.warehouse_code_list"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(_vm._s(item.warehouse_code) + "[" + _vm._s(item.warehouse_name) + "]")]);
  }), 1)], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "product_additional_add_edit_cancel",
      "id": "product_additional_add_edit_cancel",
      "data-sign": "product_additional_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "product_additional_add_edit_save",
      "id": "product_additional_add_edit_save",
      "type": "primary",
      "data-sign": "product_additional_add_edit_save",
      "loading": _vm.loading,
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };